module.exports = __webpack_public_path__ + "img/home_icon3@2x.2734e8fe.png";